module.exports = __webpack_public_path__ + "static/media/balance.5c56e3ca.png";